/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Flex, Image, Text } from '@getgo/chameleon-chakra-ui';

const messages = defineMessages({
  heading: {
    id: 'secondJoin.heading',
  },
  description: {
    id: 'secondJoin.description',
  },
});

export const SecondJoin: React.FC = () => {
  const { formatMessage: f } = useIntl();
  return (
    <Flex
      id='secondJoin'
      direction='column'
      alignItems='center'
      justifyContent='center'
    >
      <Text as='h1'>{f(messages.heading)}</Text>
      <Image
        my={12}
        src={`${process.env.PUBLIC_URL}/static/media/desktop-icon.svg`}
        alt='GoToMeeting'
        aria-hidden='true'
      />
      <Text>{f(messages.description)}</Text>
    </Flex>
  );
};
